import React, { ReactNode } from 'react'
import {
  GeneralIcon,
  InvestmentTransactionsIcon,
  SigningUpIcon,
  AccountProfileIcon,
  FeedbackComplaintsIcon,
} from '../../lib/components'
import type { FaqListResponse } from '../../services/faq-service'

export const UNCATEGORIZED_FAQ_TITLE = 'Other'

export type FaqAccordionRow = {
  id: number
  question: string
  answerHtml: string
}

export type FaqSectionView = {
  title: string
  icon: ReactNode
  details: FaqAccordionRow[]
}

export function decodeFaqTitleParam(raw: string | undefined): string {
  if (!raw) return ''
  try {
    return decodeURIComponent(raw)
  } catch {
    return raw
  }
}

export function getCategoryIcon(categoryTitle: string): ReactNode {
  const title = categoryTitle.toLowerCase()
  if (title.includes('sign')) return <SigningUpIcon />
  if (
    title.includes('investment') ||
    title.includes('transaction') ||
    title.includes('portfolio')
  ) {
    return <InvestmentTransactionsIcon />
  }
  if (title.includes('account') || title.includes('profile')) return <AccountProfileIcon />
  if (title.includes('feedback') || title.includes('complaint')) return <FeedbackComplaintsIcon />
  return <GeneralIcon />
}

export function mapFaqResponseToSections(data: FaqListResponse): FaqSectionView[] {
  return data.categories.map((g) => {
    const title = g.category?.trim() || UNCATEGORIZED_FAQ_TITLE
    return {
      title,
      icon: getCategoryIcon(title),
      details: g.items.map((it) => ({
        id: it.id,
        question: it.question,
        answerHtml: it.answer,
      })),
    }
  })
}
